// extracted by mini-css-extract-plugin
module.exports = {"EmbedPage":"EmbedPage"};